import { axius, types } from 'utils';

export const categories = (
	activeStore: types.Store
): Promise<types.Category[]> => {
	return new Promise(async (resolve) => {
		const res = await axius.get(`stores/${activeStore.code}/categories`);
		resolve((res.data || []) as types.Category[]);
	});
};
